import {
  GET_LIST,
  GET_LIST_SUCCESS,
  GET_LIST_FAILURE,
} from "actions/Auth/actionTypes";
import { createAction } from "@reduxjs/toolkit";
import {
  LOGIN_SUCCESS,
  REGISTRATION_SUCCESS,
  RESET_REGISTRATION_SUCCESS,
} from "actions/Auth/actionTypes";
import { SET_USER_INFO } from "actions/Auth/actionTypes";
import { SET_USERS_LIST, RESET_EMAIL_SENT } from "actions/Auth/actionTypes";
import { PASSWORD_RESET_SUCCESSFULLY } from "actions/Auth/actionTypes";
import { SHOW_PROGRESS, RESET_REDIRECT_STATE } from "actions/Auth/actionTypes";
import { HIDE_PROGRESS } from "actions/Auth/actionTypes";
import GeoHash from "latlon-geohash";
import { decodeGeoHash } from "utils/geoHash";

export const LOGIN_USER = createAction<LoginUserPayload>("loginUser");
export const LOGIN_USER_TOKEN = createAction<any>("loginUserToken");
export const LOGIN_SUCCESSFUL = createAction<any>("loginSuccessful");
export const DECRYPT_TOKEN = createAction<any>("decryptToken");
export const ENCRYPT_TOKEN = createAction<any>("encryptToken");
export const VERIFY_REGISTRATION =
  createAction<VerifyCodePayload>("verifyRegistration");

export const VERIFY_NON_BEAMER_REGISTRATION = createAction<VerifyCodePayload>(
  "verifyNonBeamerRegistration"
);

export const REGISTER_USER = createAction<RegisterUserPayload>("registerUser");
export const REGISTER_NON_BEAMER_USER = createAction<RegisterUserPayload>(
  "registerNonBeamerUser"
);
export const REQUEST_VERIFICATION_CODE =
  createAction<RequestVerificationCode>("forgotPassword");
export const ADD_AUTH = createAction<AddAuth>("addAuth");

export const RESET_PIN = createAction<ResetPassword>("resetPin");
export const LOGOUT_USER = createAction("logoutUser");
export const LOGOUT = createAction("logout");
export const GET_USER_INFO = createAction("getUserInfo");
export const GET_USER_AGGREGATE_INFO = createAction<any>(
  "getUserAggregateInfo"
);
export const ADD_IDENTIFIER = createAction<AddIdentifier>("add_identifier");
export const UPDATE_IDENTIFIER = createAction("update_identifier");
export const DELETE_IDENTIFIER =
  createAction<DeleteIdentifier>("delete_identifier");
export const GET_USER_ACCOUNT = createAction("getUserAccount");
export const GET_USERS_LIST = createAction<string>("GET_USERS_LIST");
export const UPDATE_USER_INFO = createAction<UpdateUser>("UPDATE_USER_INFO");
export const UPLOAD_MEDIA = createAction<any>("UPLOAD_MEDIA");
export const AUTHENTICATE_USER =
  createAction<AuthenticateUserPayload>("AUTHENTICATE_USER");
export const GET_USER_SCHEDULE = createAction("getUserSchedule");
export const VALIDATE_SCHEDULE = createAction<any>("validateSchedule");
export const DELETE_SCHEDULE = createAction<any>("deleteSchedule");
export const GET_PAGE = createAction<any>("getPage");
export const GET_FRIEND_PAGE = createAction<any>("getFriendPage");
export const GET_ALL_FRIEND_PAGE = createAction<any>("getAllFriendPage");
export const COPY_PAGE = createAction<any>("copyPage");
export const GET_ADMIN_GROUPS = createAction<any>("getAdminGroups");
export const GET_ADMIN_GROUP_MEMBERS = createAction<any>("getAdminGroupMembers");
export const INVOKE_WORKFLOW = createAction<any>("invokeWorkflow");

const initialState: AuthState = {
  getListLoading: false,
  loginSuccessfull: false,
  actionLogout: false,
  registrationSuccess: false,
  userInfo: {},
  posts: [],
  resetPinPayload: undefined,
  userIdentifier: {},
  isLoading: false,
  verificationCodeSent: false,
  verificationFailed: false,
  authenticationFailure: false,
  authenticationSuccess: false,
  identifierAdded: false,
  userSchedule: undefined,
  scheduleExist: undefined,
  lastLocation: {},
  searchBds: JSON.parse(localStorage.getItem("allUsers")) ?? undefined,
  allUsers: JSON.parse(localStorage.getItem("allUsers")) ?? undefined,
  allUsersFetched: false,
};

const getList = (state: AuthState): AuthState => ({
  ...state,
  getListLoading: true,
});

const getListSuccess = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    getListLoading: false,
    posts: action.payload,
    passwordResetSuccessfull: false,
  };
};

const getListFailed = (state: AuthState): AuthState => ({
  ...state,
  getListLoading: false,
  posts: [],
});

const getLoginSuccess = (state: AuthState): AuthState => ({
  ...state,
  loginSuccessfull: true,
  actionLogout: false,
  registeredEmail: "",
  registeredPhone: "",
  isLoading: false,
  passwordResetSuccessfull: false,
});

const getLogout = (state: AuthState): AuthState => {
  localStorage.removeItem("TOKEN");
  localStorage.removeItem("TYPE");
  localStorage.removeItem("allUsers");
  return {
    ...state,
    actionLogout: true,
    // loginSuccessfull: false,
    registeredEmail: "",
    registrationPayload: undefined,
    registeredPhone: "",
  };
};

const setLoginSuccessful = (state: AuthState, action): AuthState => {
  console.log('set login succefuu')
  return {
    ...state,
    loginSuccessfull: action,
  };
};

const setUserInfo = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    userInfo: action.payload,
  };
};

const setDecryptedToken = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    decryptedToken: action.payload.decryptedPayload,
  };
};

const setUserSchedule = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    userSchedule: action.payload,
  };
};

const validUserSchedule = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    scheduleExist: action.payload,
  };
};

const setRegistrationSuccess = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    registrationSuccess: action.payload.success,
    registeredEmail: action.payload.email,
    registeredPhone: action.payload.phone,
    registrationPayload: action.payload.payload,
    isLoading: false,
    passwordResetSuccessfull: false,
  };
};

const resetRegistrationSuccess = (state: AuthState): AuthState => {
  return {
    ...state,
    registrationSuccess: false,
    isLoading: false,
    actionSuccess: false,
  };
};

const setUsersList = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    users: action.payload,
    allUsers: state.allUsers === undefined ? action.payload : state.allUsers,
    actionSuccess: false,
  };
};

const setResetEmailPayload = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    resetPinPayload: action.payload,
    passwordResetSuccessfull: false,
    isLoading: false,
    actionSuccess: false,
  };
};

const setPasswordResetSuccess = (state: AuthState): AuthState => {
  return {
    ...state,
    resetPinPayload: undefined,
    passwordResetSuccessfull: true,
    isLoading: false,
    actionSuccess: false,
  };
};

const resetRedirectState = (state: AuthState): AuthState => {
  return {
    ...state,
    resetPinPayload: undefined,
    passwordResetSuccessfull: false,
    verificationCodeSent: false,
    actionSuccess: false,
    isLoading: false,
    verificationFailed: false,
    authenticationFailure: false,
    authenticationSuccess: false,
    identifierAdded: false,
    identifierDeleted: false,
    identifierVerified: false,
  };
};

const setUserIdentifier = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    userIdentifier: action.payload,
    actionSuccess: false,
  };
};

const setActionSuccess = (state: AuthState): AuthState => {
  return {
    ...state,
    actionSuccess: true,
  };
};

const handleVerificationCodeSent = (state: AuthState): AuthState => {
  return {
    ...state,
    verificationCodeSent: true,
    verificationFailed: false,
    isLoading: false,
  };
};

const handleVerificationFailure = (state: AuthState): AuthState => {
  return {
    ...state,
    verificationFailed: true,
    isLoading: false,
  };
};

const handleAuthenticationSuccess = (state: AuthState): AuthState => {
  return {
    ...state,
    authenticationSuccess: true,
    isLoading: false,
  };
};

const handleAuthenticationFailure = (state: AuthState): AuthState => {
  return {
    ...state,
    authenticationFailure: true,
    isLoading: false,
  };
};

const handleIdentifierAddition = (state: AuthState): AuthState => {
  return {
    ...state,
    identifierAdded: true,
    isLoading: false,
  };
};

const handleIdentifierVerified = (state: AuthState): AuthState => {
  return {
    ...state,
    identifierVerified: true,
    isLoading: false,
  };
};

const handleIdentifierDeleted = (state: AuthState): AuthState => {
  return {
    ...state,
    identifierDeleted: true,
    isLoading: false,
  };
};

const setShowProgress = (state: AuthState): AuthState => {
  return {
    ...state,
    isLoading: true,
  };
};

const setHideProgress = (state: AuthState): AuthState => {
  return {
    ...state,
    isLoading: false,
  };
};

const setSearchBds = (state: AuthState, action: any): AuthState => {
  let resolvedData = [];
  let profiles = [];
  action.payload.map((user) => {
    if (Array.isArray(user?.profile)) {
      let temp = {
        objectIds: user?.objectId,
        status: user?.status,
        profile: undefined,
        email: undefined,
        phone: undefined,
        profileImage: undefined,
        beamIds: undefined,
        roleId: undefined,
        department: undefined,
      };
      user?.profile.map((x) => {
        const parsed = JSON.parse(x)?.live;
        const admin = JSON.parse(x)?.admin;
        if(parsed?.alternativeIds?.email){
          temp.email = parsed?.alternativeIds?.email
        }
        if(parsed?.alternativeIds?.phone){
          temp.phone = parsed?.alternativeIds?.phone
        }
        if(parsed?.profile?.firstName || parsed?.profile?.firstName){
          temp.profile = parsed?.profile
        }
        if(parsed?.beamIds?.[0]){
          temp.beamIds = parsed?.beamIds
        }
        if (parsed?.profile?.profileImage?.urls?.original?.url) {
          temp.profileImage = parsed?.profile?.profileImage;
        }
        if (admin?.profile?.roleId) {
          temp.roleId = admin?.profile?.roleId;
        }
      });
      if (temp) {
        profiles.push(temp);
      }
    } else {
      profiles.push({
        objectIds: user.objectId,
        status: user?.status,
        profile: user?.profile?.live?.profile,
        beamIds: user?.profile?.live?.beamIds,
        email: user?.profile?.live?.alternativeIds?.email,
        phone: user?.profile?.live?.alternativeIds?.phone,
        profileImage: user?.profile?.live?.profile?.profileImage,
        roleId: user?.profile?.admin?.profile?.roleId
      });
    }
  });
  try {
    resolvedData = profiles
      ?.filter((user) => {
        return user.email || user.phone || user.beamIds?.[0] || user.profile?.firstName || user.profile?.lastName;
      })
      ?.map((user) => {
        return {
          id: user.objectIds.toString(),
          name:
            user?.profile?.firstName || user.profile?.lastName
              ? (user?.profile?.firstName || "") +
                " " +
                (user.profile?.lastName || "")
              : `user# ${user.objectIds.toString()}`,
          firstName: user?.profile?.firstName ?? "",
          lastName: user?.profile?.lastName ?? "",
          gender: user?.profile?.gender ?? "",
          dob: user?.profile?.dob ?? "",
          email: user.email,
          phone: user.phone,
          beamId:
            user?.beamIds?.[0]?.toLowerCase() ||
            (
              user?.profile?.firstName || user.profile?.lastName
              ? (user?.profile?.firstName?.toLowerCase() || "") +
                "." +
                (user.profile?.lastName?.toLowerCase() || "")
              : `user# ${user.objectIds.toString()}`
            ),
          profileImage: user?.profileImage ?? {},
          roleId: user?.roleId,
          status: user?.status,
        };
      });
  } catch (e) {
    console.log("something went wrong");
  }

  console.log("users", resolvedData);
  resolvedData.sort((a,b) => (a.beamId > b.beamId) ? 1 : ((b.beamId > a.beamId) ? -1 : 0))
  if (!state.allUsersFetched) {
    localStorage.setItem("allUsers", JSON.stringify(resolvedData));
  }
  return {
    ...state,
    searchBds: resolvedData,
    allUsers: !state.allUsersFetched ? resolvedData : state.allUsers,
    allUsersFetched: true,
  };
};

const setUserBds = (state: AuthState, action: any): AuthState => {
  let results = action.payload
    ?.map((x) => {
      return x?.[0];
    })
    .filter((x) => {
      return x !== "cudb-live" && x !== "cudb-root";
    });
  return {
    ...state,
    userBds: results,
  };
};

const setLastLocation = (state: AuthState, action: any): AuthState => {
  const filtered = action.payload.data.channels.filter((x) => {
    return x.timestamp && x.value;
  });
  if (filtered.length === 0)
    return {
      ...state,
    };
  const latest = filtered.reduce(function (prev, current) {
    return prev.timestamp > current.timestamp ? prev : current;
  });
  const segments = latest.objectId.split(":");
  const lastLocation = state.lastLocation;
  lastLocation[action.payload.id] = {
    userId: action.payload.id,
    timestamp: latest.timestamp,
    // location: GeoHash.decode(latest.value.toString()),
    location: decodeGeoHash(latest.value),
    objectId: latest.objectId,
    iotUdid: segments?.[1],
    iotUserId: segments?.[2],
    imei: `${process.env.REACT_APP_ECO_SYSTEM}/device/${segments?.[1]}/user/${action.payload.id}/iotAppend/${segments?.[2]}/gps`,
  };
  return {
    ...state,
    lastLocation: { ...lastLocation },
  };
};

const setFullLastLocation = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    lastLocation: action.payload,
  };
};

const authReducer = (
  state: AuthState = initialState,
  action: any
): AuthState => {
  switch (action.type) {
    case GET_LIST:
      return getList(state);
    case "loginUser":
      return {
        ...state,
        registrationSuccess: false,
      };
    case GET_LIST_SUCCESS:
      return getListSuccess(state, action);
    case GET_LIST_FAILURE:
      return getListFailed(state);
    case LOGIN_SUCCESS:
      return getLoginSuccess(state);
    case SET_USER_INFO:
      return setUserInfo(state, action);
    case REGISTRATION_SUCCESS:
      return setRegistrationSuccess(state, action);
    case RESET_REGISTRATION_SUCCESS:
      return resetRegistrationSuccess(state);
    case SET_USERS_LIST:
      return setUsersList(state, action);
    case RESET_EMAIL_SENT:
      return setResetEmailPayload(state, action);
    case PASSWORD_RESET_SUCCESSFULLY:
      return setPasswordResetSuccess(state);
    case SHOW_PROGRESS:
      return setShowProgress(state);
    case HIDE_PROGRESS:
      return setHideProgress(state);
    case RESET_REDIRECT_STATE:
      return resetRedirectState(state);
    case "SET_USER_IDENTIFIERS":
      return setUserIdentifier(state, action);
    case "ACTION_SUCCESS":
      return setActionSuccess(state);
    case "VERIFICATION_CODE_SENT":
      return handleVerificationCodeSent(state);
    case "VERIFICATION_FAILED":
      return handleVerificationFailure(state);
    case "AUTHENTICATION_SUCCESSFULL":
      return handleAuthenticationSuccess(state);
    case "AUTHENTICATION_FAILED":
      return handleAuthenticationFailure(state);
    case "IDENTIFIER_ADDED":
      return handleIdentifierAddition(state);
    case "IDENTIFIER_VERIFIED":
      return handleIdentifierVerified(state);
    case "IDENTIFIER_DELETED":
      return handleIdentifierDeleted(state);
    case "logoutUser":
      return getLogout(state);
    case "registerNonBeamerUser":
      return setLoginSuccessful(state, false);
    case "LOGIN_SUCCESSFUL":
      return setLoginSuccessful(state, true);  
    case "ADD_DECRYPTED_TOKEN":
      return setDecryptedToken(state, action);
    case "SET_USER_SCHEDULE":
      return setUserSchedule(state, action);
    case "VALIDATE_USER_SCHEDULE":
      return validUserSchedule(state, action);
    case "FIND_USERS_TO_PAGE":
      return {
        ...state,
        findUsersToPage: action.payload,
      };
    case "VIDEO_IOT":
      return {
        ...state,
        videoIot: action.payload,
      };
    case "SEARCH_BDS":
      return setSearchBds(state, action);
    case "USER_BDS":
      return setUserBds(state, action);
    case "SET_GPS_LAST_LOCATION":
      return setLastLocation(state, action);
    case "SET_FULL_GPS_LAST_LOCATION":
      return setFullLastLocation(state, action);
    default:
      return state;
  }
};

export default authReducer;
